// extracted by mini-css-extract-plugin
export default {"icon":"Items_icon__6O3Bz"};